import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AnnouncementsListRoute extends Route {
  @service router;

  model() {
    const { announcements } = this.modelFor('protect.announcements');

    return {
      announcements,
    };
  }

  afterModel({ announcements }) {
    if (!announcements.length) {
      this.router.transitionTo('protect.announcements.landing-page');
    }
  }
}
